<template>
  <div>
    <div class="mypage__upload mypage__upload-employee text-center w-100">
      <div class="avatar avatar-center">
        <img :src="user.avatar" alt class="avt-modal"/>
      </div>
    </div>
    <div class="mypage__title text-center">
      {{truncate(show(user.name),15,'...')}}
    </div>
    <div class="mypage__job text-center">{{show(user.position)}}</div>
    <ul class="mypage__ul">
      <li class="mypage__li" :class="{active: activeIsInformation}">
        <router-link class="mypage__list" :to="{name: 'employee_me'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.25" height="15.25" viewBox="0 0 15.25 15.25">
            <g id="Icon_feather-info" data-name="Icon feather-info" transform="translate(0.625 0.625)">
              <path id="Path_9869" data-name="Path 9869" d="M17,10a7,7,0,1,1-7-7,7,7,0,0,1,7,7Z" transform="translate(-3 -3)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
              <path id="Path_9870" data-name="Path 9870" d="M18,20.8V18" transform="translate(-11 -11)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
              <path id="Path_9871" data-name="Path 9871" d="M18,12h0" transform="translate(-11 -7.8)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
            </g>
          </svg>
          <span class="mypage_li_name">個人情報</span>
        </router-link>
      </li>
      <li class="mypage__li" :class="{active: activeIsFavorite}">
        <router-link class="mypage__list" :to="{name: 'employee_me_favorite'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.25" height="15.25" viewBox="0 0 18.573 16.453">
            <path id="Path_25128" data-name="Path 25128" d="M12.905-12.25a4.506,4.506,0,0,0-2.437.686A4.657,4.657,0,0,0,8.787-9.779,4.657,4.657,0,0,0,7.1-11.564a4.506,4.506,0,0,0-2.437-.686,4.5,4.5,0,0,0-1.811.369,4.758,4.758,0,0,0-1.484,1,4.758,4.758,0,0,0-1,1.484A4.5,4.5,0,0,0,0-7.582,7.4,7.4,0,0,0,1.373-3.249,18.068,18.068,0,0,0,4.393.132a20.246,20.246,0,0,0,3.02,2.205l1.373.789,1.373-.781a19.73,19.73,0,0,0,3.02-2.2A17.95,17.95,0,0,0,16.2-3.24a7.439,7.439,0,0,0,1.373-4.342A4.5,4.5,0,0,0,17.2-9.393a4.758,4.758,0,0,0-1-1.484,4.758,4.758,0,0,0-1.484-1A4.5,4.5,0,0,0,12.905-12.25Z" transform="translate(0.5 12.75)" fill="none" stroke="#333" stroke-width="1"/>
          </svg>
          <span class="mypage_li_name">お気に入り ({{total_files}})</span>
        </router-link>
      </li>
      <li class="mypage__li" :class="{active: activeIsHistory}">
        <router-link class="mypage__list" :to="{name: 'employee_me_history'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.281" height="15.281" viewBox="0 0 15.281 15.281">
            <g id="Icon_feather-clock" data-name="Icon feather-clock" transform="translate(0.625 0.625)">
              <path id="Path_9872" data-name="Path 9872" d="M17.031,10.015A7.015,7.015,0,1,1,10.015,3a7.015,7.015,0,0,1,7.015,7.015Z" transform="translate(-3 -3)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
              <path id="Path_9873" data-name="Path 9873" d="M18,9v4.209l2.806,1.4" transform="translate(-10.985 -6.194)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
            </g>
          </svg>
          <span class="mypage_li_name">観覧履歴</span>
        </router-link>
      </li>
      <li class="mypage__li" :class="{active: activeIsSetting}">
        <router-link class="mypage__list" :to="{name: 'employee_me_setting'}">
          <svg xmlns="http://www.w3.org/2000/svg" width="15.582" height="15.582" viewBox="0 0 15.582 15.582">
            <g id="Icon_feather-settings" data-name="Icon feather-settings" transform="translate(-0.875 -0.875)">
              <path id="Path_9874" data-name="Path 9874" d="M17.409,15.454A1.954,1.954,0,1,1,15.454,13.5,1.954,1.954,0,0,1,17.409,15.454Z" transform="translate(-6.789 -6.789)" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
              <path id="Path_9875" data-name="Path 9875" d="M13.486,10.62a1.075,1.075,0,0,0,.215,1.186l.039.039A1.3,1.3,0,1,1,11.9,13.688l-.039-.039a1.084,1.084,0,0,0-1.837.769v.111a1.3,1.3,0,1,1-2.606,0V14.47A1.128,1.128,0,0,0,5.526,13.7l-.039.039A1.3,1.3,0,1,1,3.643,11.9l.039-.039a1.084,1.084,0,0,0-.769-1.837H2.8a1.3,1.3,0,1,1,0-2.606h.059A1.128,1.128,0,0,0,3.63,5.526l-.039-.039A1.3,1.3,0,1,1,5.435,3.643l.039.039A1.075,1.075,0,0,0,6.659,3.9h.052a1.075,1.075,0,0,0,.651-.984V2.8a1.3,1.3,0,1,1,2.606,0v.059a1.084,1.084,0,0,0,1.837.769l.039-.039a1.3,1.3,0,1,1,1.844,1.844l-.039.039a1.075,1.075,0,0,0-.215,1.186v.052a1.075,1.075,0,0,0,.984.651h.111a1.3,1.3,0,1,1,0,2.606H14.47a1.075,1.075,0,0,0-.984.651Z" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.25"/>
            </g>
          </svg>
          <span class="mypage_li_name">通知設定</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'SidebarMypage',
  props: {
    myPage: {type: String, default: null}
  },
  computed: {
    ...mapState({
      user: state => state.allAuth.user,
      total_files: state => state.employeeMyPage.metadataFavorite.total_files
    }),
    activeIsInformation () {
      return this.myPage === 'information'
    },
    activeIsFavorite () {
      return this.myPage === 'favorite'
    },
    activeIsHistory () {
      return this.myPage === 'history'
    },
    activeIsSetting () {
      return this.myPage === 'setting'
    }
  },
  methods: {
    show (value) {
      return value === null ? '' : value
    }
  },
  mounted () {
    this.$store.dispatch('employeeMyPage/getFavorite')
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/views/Employee/MyPage/SidebarMypage.vue